<template>
  <div>
    <div class="container">
      <div class="text flex fw-700 flex-column items-center justify-center">
        <h2 class="fs-40 fw-700 mb-fs-32 lh-52 mb-8 ls-1 tc">
          {{ FAQ_HEADER }}
        </h2>
        <p class="fs-16 lh-20 gray-dark ls-1 mb-60 mb-mb-20">
          {{ $route.name === SCHOOL_TOUR_ROUTE.name ? SCHOOL_FAQ_SUBHEADER : FAQ_SUBHEADER }}
        </p>
      </div>
      <div class="faq-list-cards flex flex-column grid-gap-8">
        <CGTFAQCard
          v-for="(item, index) in faqContent"
          :key="index"
          :question="item.question"
          :answer="item.answer"
          :shouldOpen="item.isOpen"
        />
      </div>
      <CGTFAQContacUs />
    </div>
  </div>
</template>

<script setup>
import {
  FAQ_CONTENT,
  FAQ_HEADER,
  FAQ_SUBHEADER
} from '~/constant/customGroupTours'
import {
  SCHOOL_FAQ_CONTENT,
  SCHOOL_FAQ_SUBHEADER
} from '~/constant/schoolTourDetails'
import CGTFAQCard from '~/components/pages/LandingPage/CGTFAQ/CGTFAQCard.vue'
import CGTFAQContacUs from '~/components/pages/LandingPage/CGTFAQ/CGTFAQContacUs.vue'
import { useRoute } from 'vue-router'
import { SCHOOL_TOUR_ROUTE } from '~/constant/common.js'
import { computed } from 'vue'

const route = useRoute()

const getFAQContent = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return SCHOOL_FAQ_CONTENT
  return FAQ_CONTENT
})

const faqContent = ref(getFAQContent.value.map((v)=> ({ ...v, isOpen: true })))


onMounted(()=> {
  faqContent.value = getFAQContent.value.map((v, i)=> ({ ...v, isOpen: i === 0 }))
})
</script>

<style lang="scss" scoped></style>
